const SCENE_TYPE = {
  AERIAL: 'AERIAL',
  AERIAL_MAP: 'AERIAL_MAP',
  GROUND: 'GROUND',
  LANDING: 'LANDING',
};

export default SCENE_TYPE;
